var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-block',_vm._b({on:{"block-selected":_vm.selectBlock}},'cms-block',_vm.$props,false),[_c('cms-component-text',{attrs:{"comp-id":"content","component":_vm.block.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }